import { useMediaQuery } from "@shared/hooks/useMediaQuery";
import useQueryParams from "@shared/hooks/useQueryParams";
import { useMemo, useState } from "react";

export const useCategorySlider = () => {
  const { setParam, removeParamByKey, getParam } = useQueryParams();
  const isMobile = useMediaQuery("(max-width:576px)");

  const initialCategory = getParam("category") || undefined;
  const [currentCategory, setCurrentCategory] = useState<string | undefined>(
    initialCategory
  );

  const handleSelect = (id: number) => {
    const value = String(id);

    setCurrentCategory(value);
    removeParamByKey(["page", "category"]);
    setParam({ key: "category", value, redirect: true });
  };

  const handleClear = () => {
    setCurrentCategory(undefined);
    removeParamByKey(["category", "page"], true);
  };
  return {
    handleClear,
    handleSelect,
    isMobile,
    currentCategory,
  };
};
